/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./StickersTabs.scss";
import { renderList } from "common/vue/render-list";

export default function StickersTabs({ tabs, artwork, children, ...restProps }: any) {
  const [tab, setTab] = useState(tabs[0].value);

  function handleClick(item: any) {
    if (artwork.processingImage) return;
    setTab(item.value);
  }

  return (
    <div {...restProps} className={cn("stickers-tabs", restProps.className)}>
      <div className="stickers-tabs__items">
        {renderList(tabs, item => (
          <button
            className={cn("stickers-tabs__item", {
              "stickers-tabs__item--active": item.value === tab
            })}
            key={item.value}
            type="button"
            onClick={e => {
              e.preventDefault();
              handleClick(item);
            }}
            data-testid="stickers-tabs-item"
          >
            <UseSvg
              className="stickers-tabs__icon"
              icon={item.icon}
              width="24"
              height="24"
              data-testid="stickers-tabs-icon"
            />{" "}
            {item.label}
          </button>
        ))}
      </div>
      {children}
    </div>
  );
}
